import React, { Component, Fragment } from 'react'
import PropTypes from 'prop-types'

import { withTranslation } from 'react-i18next'

import { newsCommunicator } from '../../../communicators/newsCommunicator'

import NewsSection from '../../components/NewsSection/NewsSection'

class SectorNewsSection extends Component {
    constructor(props) {
        super(props)

        this.state = {
            news: [],
            sectorImage: ''
        }
    }

    componentDidMount() {
        this.loadNews()
    }

    async loadNews() {
        try {
            const { sectorId } = this.props
            const news = await newsCommunicator.fetchPage(3, null, { sector_id: sectorId })

            this.setState({ news })
        } catch (error) {
            console.error(error)
        }
    }

    render() {
        const { t, sectorSlug } = this.props
        const { news } = this.state

        return (
            <Fragment>
                {news && (
                    <NewsSection
                        title={t('sector.newsSection.title')}
                        newsList={news}
                        detailsTitle={t('sector.newsSection.details')}
                        link={`/sve-vesti/sektor/${sectorSlug}`}
                    />
                )}
            </Fragment>
        )
    }
}

SectorNewsSection.propTypes = {
    t: PropTypes.func,
    sectorId: PropTypes.number.isRequired
}

export { SectorNewsSection }
export default withTranslation()(SectorNewsSection)
